import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Receipt, ReceiptCreateDTO, ReceiptEditDTO, ReceiptEditHistory, OnAccountReceiptCreateDTO } from '../interfaces/sales/receipt.interface';

export const ReceiptService = {
  listByInvoice: async (invoiceId: string): Promise<Receipt[]> =>
    (await axios.get(ENDPOINTS.RECEIPT.LIST_BY_INVOICE(invoiceId))).data,
  getById: async (id: string): Promise<Receipt> =>
    (await axios.get(ENDPOINTS.RECEIPT.GET_BY_ID(id))).data,
  create: async (dto: ReceiptCreateDTO): Promise<Receipt> =>
    (await axios.post(ENDPOINTS.RECEIPT.CREATE, dto)).data,
  reverse: async (id: string): Promise<Receipt> =>
    (await axios.post(ENDPOINTS.RECEIPT.REVERSE(id))).data,
  edit: async (id: string, dto: ReceiptEditDTO): Promise<Receipt> =>
    (await axios.put(ENDPOINTS.RECEIPT.EDIT(id), dto)).data,
  editHistory: async (id: string): Promise<ReceiptEditHistory[]> =>
    (await axios.get(ENDPOINTS.RECEIPT.EDIT_HISTORY(id))).data,
  createOnAccount: async (dto: OnAccountReceiptCreateDTO): Promise<Receipt> =>
    (await axios.post(ENDPOINTS.RECEIPT.ON_ACCOUNT, dto)).data,
  listUnappliedByCustomer: async (customerId: string): Promise<Receipt[]> =>
    (await axios.get(ENDPOINTS.RECEIPT.UNAPPLIED_BY_CUSTOMER(customerId))).data,
  // W3-E: amount omitted = as much as the receipt's unapplied balance and the invoice outstanding allow.
  apply: async (id: string, salesInvoiceId: string, amount?: number): Promise<Receipt> =>
    (await axios.post(ENDPOINTS.RECEIPT.APPLY(id), amount === undefined ? { salesInvoiceId } : { salesInvoiceId, amount })).data,
  downloadPdf: async (id: string): Promise<Blob> =>
    (await axios.get(ENDPOINTS.RECEIPT.PDF(id), { responseType: 'blob' })).data,
};
